import { BaseApi } from '@/main/baseApi';

import { NAME, DMS_MODULE } from './constants';

export const apiProvider = new BaseApi(DMS_MODULE, NAME);
